import LPFacebookIcon from '/static/svg/icon-lp-facebook.svg'
import LPInstagramIcon from '/static/svg/icon-lp-instagram.svg'
import LPYoutubeIcon from '/static/svg/icon-lp-youtube.svg'
import LPLinkedinIcon from '/static/svg/icon-lp-linkedin.svg'

export const socialMediaIcons = [
  {
    url: 'https://www.facebook.com/gruporecovery/',
    id: '1',
    name: 'facebook',
    icon: <LPFacebookIcon />,
  },
  {
    url: 'https://www.instagram.com/grupo.recovery/',
    id: '2',
    name: 'instagram',
    icon: <LPInstagramIcon />,
  },
  {
    url: 'https://www.youtube.com/channel/UCBD5A22wtRcNGDBjM2bK5LQ',
    id: '3',
    name: 'youtube',
    icon: <LPYoutubeIcon />,
  },
  {
    url: 'https://www.linkedin.com/company/gruporecovery/',
    id: '4',
    name: 'linkedin',
    icon: <LPLinkedinIcon />,
  },
]
